var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlace = function SvgPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    x: 1.5,
    y: 1.535,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#place_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.808 9.535 7.5 20.827h3.996l1.499-3.917 2.506 4.625 2.504-4.625 1.504 3.917H23.5L19.192 9.535l-3.69 5.797z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "place_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5 9.535h16v12h-16z"
  })))));
};
export default SvgPlace;